export const ALLOWED_EXTENSIONS = ['docx', 'doc', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'png', 'jpg', 'jpeg', 'odt', 'ods', 'odp', 'rtf', 'csv'];
export const ACCEPT_STRING = '.' + ALLOWED_EXTENSIONS.join(',.');
export const MAX_FILE_SIZE = 4 * 1024 * 1024; // 4 MB
export const MAX_FILE_COUNT = 10;
export const MAX_FILENAME_LENGTH = 120;